module.exports = __webpack_public_path__ + "f84a8be5b9f1b3ef29b3400a456f623e.png";